(function () {
  if (window.WSTNUX) {
    return;
  }

  var MOTION = {
    COUNTUP_DURATION: 2000,
    REVEAL_DURATION: 1000
  };
  var reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var revealObserver = null;
  var countObserver = null;

  function prefersReducedMotion() {
    return reduceMotionQuery.matches;
  }

  function syncMotionConstants() {
    document.documentElement.style.setProperty('--wstn-motion-countup-duration', MOTION.COUNTUP_DURATION + 'ms');
    document.documentElement.style.setProperty('--wstn-motion-reveal-duration', MOTION.REVEAL_DURATION + 'ms');
  }

  function parseNumericText(raw) {
    if (!raw) {
      return null;
    }

    var match = raw.trim().match(/^([^0-9-]*)(-?\d[\d,]*\.?\d*)(.*)$/);

    if (!match) {
      return null;
    }

    var prefix = match[1] || '';
    var numericText = match[2].replace(/,/g, '');
    var suffix = match[3] || '';
    var value = parseFloat(numericText);

    if (Number.isNaN(value)) {
      return null;
    }

    var decimalMatch = numericText.match(/\.(\d+)$/);

    return {
      prefix: prefix,
      value: value,
      suffix: suffix,
      decimals: decimalMatch ? decimalMatch[1].length : 0,
      original: raw.trim()
    };
  }

  function formatNumericText(parsed, value) {
    return parsed.prefix + value.toLocaleString(undefined, {
      minimumFractionDigits: parsed.decimals,
      maximumFractionDigits: parsed.decimals
    }) + parsed.suffix;
  }

  function markRevealVisible(element) {
    element.classList.add('is-visible');
  }

  function initReveal(root) {
    var elements = root.querySelectorAll('[data-wstn-reveal]');

    elements.forEach(function (element) {
      if (element.dataset.wstnRevealReady === 'true') {
        return;
      }

      element.dataset.wstnRevealReady = 'true';

      if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
        markRevealVisible(element);
        return;
      }

      if (!revealObserver) {
        revealObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              return;
            }

            markRevealVisible(entry.target);
            revealObserver.unobserve(entry.target);
          });
        }, {
          threshold: 0.18,
          rootMargin: '0px 0px -8% 0px'
        });
      }

      revealObserver.observe(element);
    });
  }

  function runCountup(element) {
    if (element.dataset.wstnCounted === 'true') {
      return;
    }

    var parsed = parseNumericText(element.dataset.wstnCountOriginal || element.textContent);

    if (!parsed) {
      element.dataset.wstnCounted = 'true';
      return;
    }

    if (prefersReducedMotion()) {
      element.textContent = parsed.original;
      element.dataset.wstnCounted = 'true';
      return;
    }

    var duration = MOTION.COUNTUP_DURATION;
    var startTime = null;

    function frame(timestamp) {
      if (!startTime) {
        startTime = timestamp;
      }

      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var currentValue = parsed.value * eased;

      element.textContent = formatNumericText(parsed, currentValue);

      if (progress < 1) {
        requestAnimationFrame(frame);
      } else {
        element.textContent = parsed.original;
        element.dataset.wstnCounted = 'true';
      }
    }

    requestAnimationFrame(frame);
  }

  function initCountups(root) {
    var elements = root.querySelectorAll('[data-wstn-countup]');

    elements.forEach(function (element) {
      if (element.dataset.wstnCountReady === 'true') {
        return;
      }

      var parsed = parseNumericText(element.textContent);

      if (!parsed) {
        element.dataset.wstnCountReady = 'true';
        element.dataset.wstnCounted = 'true';
        return;
      }

      element.dataset.wstnCountReady = 'true';
      element.dataset.wstnCountOriginal = parsed.original;

      if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
        element.dataset.wstnCounted = 'true';
        element.textContent = parsed.original;
        return;
      }

      if (!countObserver) {
        countObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              return;
            }

            runCountup(entry.target);
            countObserver.unobserve(entry.target);
          });
        }, {
          threshold: 0.35,
          rootMargin: '0px 0px -5% 0px'
        });
      }

      countObserver.observe(element);
    });
  }

  /* --------------------------------------------------------------------------------------
     Sound clip URLs (owner round 6, 17-09-2026)

     The raw audio URL is never allowed on screen, on any surface. The product page strips it
     server side and the accordion strips it again as it builds, but neither of those covers a
     surface they do not own: a collection page description, a quick view drawer whose HTML is
     fetched and injected long after load, a search result, a rerendered block, an app that
     prints a description. This sweep is the page wide net.

     It runs on load, on every section load, on every product rerender, and on anything added to
     the document afterwards. It also clears the flag the stylesheet uses to hold a description
     back from painting, so a page where the accordion's own script never ran still shows its
     copy — swept — rather than staying blank.
     -------------------------------------------------------------------------------------- */
  var AUDIO_URL_SOURCE = 'https?:\\/\\/[^\\s"\'<>]+\\.(?:mp4|mp3|m4a|wav|ogg|aac)(?:[?#][^\\s"\'<>]*)?';
  var AUDIO_HREF_SOURCE = '\\.(?:mp4|mp3|m4a|wav|ogg|aac)(?:[?#]|$)';
  var SCRUB_CONTAINERS = '.rte, .wstn-accordion, .wstn-accordion__source, .wstn-soundtile, .product-form__description, .product-tabs__tab-item-content';
  var SCRUB_SOURCES = '.wstn-accordion__source';

  /* Where an anchor with an empty href may be removed. An empty href is only ever left behind by
     the server side scrub of a PRODUCT description, so the removal is kept to the containers a
     product description renders in. SCRUB_CONTAINERS also matches every other .rte on the store,
     and removing empty href anchors there took them out of blog posts and ordinary pages too,
     where an empty href belongs to the merchant rather than to the scrub. Audio hrefs are still
     removed everywhere SCRUB_CONTAINERS reaches. */
  var EMPTY_HREF_CONTAINERS = '.wstn-accordion, .wstn-accordion__source, .wstn-soundtile, .product-form__description, .product-tabs__tab-item-content';
  var pendingScrubNodes = [];
  var scrubTimer = null;

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  // "Hear it cold start and pull: <link>" must not be left as "Hear it cold start and pull:",
  // so the punctuation that pointed at the link goes with it.
  function tidyBefore(node) {
    var previous = node.previousSibling;

    if (!previous || previous.nodeType !== 3) {
      return;
    }

    previous.nodeValue = (previous.nodeValue || '').replace(/\s*[:\-\u2013\u2014]\s*$/, '');
  }

  // True when this container is a product description scope, or sits inside one. Only there is
  // an empty href a leftover of the scrub rather than the merchant's own markup.
  function allowsEmptyHrefRemoval(container) {
    try {
      if (container.matches && container.matches(EMPTY_HREF_CONTAINERS)) {
        return true;
      }

      return !!(container.closest && container.closest(EMPTY_HREF_CONTAINERS));
    } catch (error) {
      return false;
    }
  }

  function scrubContainer(container) {
    try {
      var removeEmptyHrefs = allowsEmptyHrefRemoval(container);

      toArray(container.querySelectorAll('a[href]')).forEach(function (link) {
        var href = (link.getAttribute('href') || '').trim();

        // An empty href is what the server side scrub leaves behind when it takes a URL out of
        // a link, so the dead anchor goes with it, inside a product description only.
        if (href === '') {
          if (removeEmptyHrefs) {
            tidyBefore(link);
            link.remove();
          }

          return;
        }

        if (new RegExp(AUDIO_HREF_SOURCE, 'i').test(href)) {
          tidyBefore(link);
          link.remove();
        }
      });

      ['title', 'aria-label'].forEach(function (attribute) {
        toArray(container.querySelectorAll('[' + attribute + ']')).forEach(function (node) {
          var value = node.getAttribute(attribute) || '';

          if (new RegExp(AUDIO_URL_SOURCE, 'i').test(value)) {
            node.setAttribute(attribute, value.replace(new RegExp(AUDIO_URL_SOURCE, 'ig'), '').trim());
          }
        });
      });

      if (!new RegExp(AUDIO_URL_SOURCE, 'i').test(container.textContent || '')) {
        return;
      }

      var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null, false);
      var nodes = [];

      while (walker.nextNode()) {
        nodes.push(walker.currentNode);
      }

      nodes.forEach(function (node) {
        var text = node.nodeValue || '';

        if (!new RegExp(AUDIO_URL_SOURCE, 'i').test(text)) {
          return;
        }

        node.nodeValue = text
          .replace(new RegExp(AUDIO_URL_SOURCE, 'ig'), '')
          .replace(/[ \t]{2,}/g, ' ')
          .replace(/\s*[:\-–—]\s*$/, '');
      });
    } catch (error) {
      /* one unreadable container must never stop the rest of the sweep */
    }
  }

  function scrubAudioUrls(root) {
    var scope = root || document;
    var containers = [];

    try {
      if (scope.nodeType === 1 && scope.matches && scope.matches(SCRUB_CONTAINERS)) {
        containers.push(scope);
      }

      if (scope.querySelectorAll) {
        containers = containers.concat(toArray(scope.querySelectorAll(SCRUB_CONTAINERS)));
      }

      containers.forEach(scrubContainer);
    } catch (error) {
      /* fall through to the reveal below: the copy is never left hidden by a failure here */
    } finally {
      try {
        var sources = [];

        if (scope.nodeType === 1 && scope.matches && scope.matches(SCRUB_SOURCES)) {
          sources.push(scope);
        }

        if (scope.querySelectorAll) {
          sources = sources.concat(toArray(scope.querySelectorAll(SCRUB_SOURCES)));
        }

        sources.forEach(function (source) {
          source.setAttribute('data-wstn-desc-safe', 'true');
        });
      } catch (error) {
        /* nothing further to do */
      }
    }
  }

  /* A timer, deliberately not requestAnimationFrame: a tab in the background does not paint, so
     rAF does not run there, and the sweep would sit queued while a quick view drawer opened in
     that tab with a URL still in it. Timers keep running in a background tab. */
  function flushScrubQueue() {
    scrubTimer = null;

    var nodes = pendingScrubNodes;
    pendingScrubNodes = [];

    nodes.forEach(scrubAudioUrls);
  }

  function watchForInjectedContent() {
    if (!('MutationObserver' in window) || document.documentElement.dataset.wstnScrubWatching === 'true') {
      return;
    }

    document.documentElement.dataset.wstnScrubWatching = 'true';

    var observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        toArray(record.addedNodes).forEach(function (node) {
          if (node.nodeType !== 1) {
            return;
          }

          pendingScrubNodes.push(node);
        });
      });

      if (pendingScrubNodes.length > 0 && !scrubTimer) {
        scrubTimer = setTimeout(flushScrubQueue, 0);
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function getSlideLeft(track, slide) {
    return slide.offsetLeft - track.offsetLeft;
  }

  function initSlider(root) {
    var sliders = root.querySelectorAll('[data-wstn-slider]');

    sliders.forEach(function (slider) {
      if (slider.dataset.wstnSliderReady === 'true') {
        return;
      }

      var track = slider.querySelector('[data-wstn-slider-track]');
      var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-wstn-slide]')) : [];

      if (!track || slides.length === 0) {
        slider.dataset.wstnHasOverflow = 'false';
        slider.dataset.wstnSliderReady = 'true';
        return;
      }

      var previousButton = slider.querySelector('[data-wstn-slider-prev]');
      var nextButton = slider.querySelector('[data-wstn-slider-next]');
      var dotsContainer = slider.querySelector('[data-wstn-slider-dots]');
      var activeIndex = 0;

      function setOverflowState() {
        var hasOverflow = track.scrollWidth > track.clientWidth + 2;
        slider.dataset.wstnHasOverflow = hasOverflow ? 'true' : 'false';
        return hasOverflow;
      }

      function updateActiveIndex() {
        var closestIndex = 0;
        var closestDistance = Infinity;

        slides.forEach(function (slide, index) {
          var distance = Math.abs(track.scrollLeft - getSlideLeft(track, slide));

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        activeIndex = closestIndex;

        if (previousButton) {
          previousButton.disabled = activeIndex === 0;
        }

        if (nextButton) {
          nextButton.disabled = activeIndex >= slides.length - 1;
        }

        if (dotsContainer) {
          Array.prototype.slice.call(dotsContainer.querySelectorAll('[data-wstn-slider-dot]')).forEach(function (dot, index) {
            dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
          });
        }
      }

      function scrollToIndex(index) {
        var boundedIndex = Math.max(0, Math.min(index, slides.length - 1));
        var left = getSlideLeft(track, slides[boundedIndex]);

        track.scrollTo({
          left: left,
          behavior: prefersReducedMotion() ? 'auto' : 'smooth'
        });
      }

      if (dotsContainer && dotsContainer.childElementCount === 0) {
        slides.forEach(function (_, index) {
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'wstn-slider__dot';
          button.dataset.wstnSliderDot = 'true';
          button.setAttribute('aria-label', 'Go to slide ' + (index + 1));
          button.addEventListener('click', function () {
            scrollToIndex(index);
          });
          dotsContainer.appendChild(button);
        });
      }

      if (previousButton) {
        previousButton.addEventListener('click', function () {
          scrollToIndex(activeIndex - 1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          scrollToIndex(activeIndex + 1);
        });
      }

      var scrollFrame = null;

      track.addEventListener('scroll', function () {
        if (scrollFrame) {
          cancelAnimationFrame(scrollFrame);
        }

        scrollFrame = requestAnimationFrame(updateActiveIndex);
      }, {
        passive: true
      });

      window.addEventListener('resize', function () {
        setOverflowState();
        updateActiveIndex();
      }, {
        passive: true
      });

      document.addEventListener('shopify:block:select', function (event) {
        var selectedSlide = event.target.closest('[data-wstn-slide]');

        if (!selectedSlide || !slider.contains(selectedSlide)) {
          return;
        }

        var index = slides.indexOf(selectedSlide);

        if (index > -1) {
          scrollToIndex(index);
        }
      });

      setOverflowState();
      updateActiveIndex();
      slider.dataset.wstnSliderReady = 'true';
    });
  }

  function initMarquees(root) {
    var marquees = root.querySelectorAll('[data-wstn-marquee]');

    marquees.forEach(function (marquee) {
      if (marquee.dataset.wstnMarqueeBase == null) {
        var initialGroup = marquee.querySelector('[data-wstn-marquee-group]');
        marquee.dataset.wstnMarqueeBase = initialGroup ? initialGroup.innerHTML : '';
      }

      if (marquee.dataset.wstnMarqueeReady === 'true') {
        return;
      }

      var viewport = marquee.querySelector('[data-wstn-marquee-viewport]');
      var track = marquee.querySelector('[data-wstn-marquee-track]');
      var groups = marquee.querySelectorAll('[data-wstn-marquee-group]');

      if (!viewport || !track || groups.length < 2 || marquee.dataset.wstnMarqueeBase === '') {
        marquee.dataset.wstnMarqueeReady = 'true';
        return;
      }

      var resizeFrame = null;

      function syncGroups() {
        var baseMarkup = marquee.dataset.wstnMarqueeBase;

        groups[0].innerHTML = baseMarkup;
        groups[1].innerHTML = baseMarkup;

        if (prefersReducedMotion()) {
          track.style.removeProperty('--wstn-marquee-shift');
          return;
        }

        var iterations = 0;

        while (groups[0].scrollWidth < viewport.clientWidth + 48 && iterations < 8) {
          groups[0].insertAdjacentHTML('beforeend', baseMarkup);
          iterations += 1;
        }

        groups[1].innerHTML = groups[0].innerHTML;
        track.style.setProperty('--wstn-marquee-shift', groups[0].scrollWidth + 'px');
      }

      syncGroups();

      window.addEventListener('resize', function () {
        if (resizeFrame) {
          cancelAnimationFrame(resizeFrame);
        }

        resizeFrame = requestAnimationFrame(syncGroups);
      }, {
        passive: true
      });

      marquee.dataset.wstnMarqueeReady = 'true';
    });
  }

  function parseReviewPayload(payload) {
    if (!payload) {
      return null;
    }

    var ratingValueMatch = payload.match(/ratingValue"\s*:\s*"?([0-9.]+)"?/i);
    var reviewCountMatch = payload.match(/(?:reviewCount|ratingCount)"\s*:\s*"?([0-9]+)"?/i);
    var ratingValue = ratingValueMatch ? parseFloat(ratingValueMatch[1]) : null;
    var reviewCount = reviewCountMatch ? parseInt(reviewCountMatch[1], 10) : null;

    if (!ratingValue || !reviewCount) {
      return null;
    }

    return {
      ratingValue: ratingValue,
      reviewCount: reviewCount
    };
  }

  function initReviewSummaries(root) {
    var summaries = root.querySelectorAll('[data-wstn-review-summary]');

    summaries.forEach(function (summary) {
      if (summary.dataset.wstnReviewReady === 'true') {
        return;
      }

      summary.dataset.wstnReviewReady = 'true';

      if (summary.querySelector('.rating')) {
        return;
      }

      var parsed = parseReviewPayload(summary.getAttribute('data-wstn-review-payload'));

      if (!parsed) {
        summary.classList.add('is-hidden');
        return;
      }

      var meter = document.createElement('span');
      var base = document.createElement('span');
      var fill = document.createElement('span');
      var count = document.createElement('span');
      var percentage = Math.max(0, Math.min(parsed.ratingValue / 5, 1)) * 100;

      meter.className = 'wstn-inline-rating__meter';
      meter.setAttribute('aria-hidden', 'true');
      base.className = 'wstn-inline-rating__meter-base';
      fill.className = 'wstn-inline-rating__meter-fill';
      fill.style.width = percentage + '%';
      base.textContent = '★★★★★';
      fill.textContent = '★★★★★';
      meter.appendChild(base);
      meter.appendChild(fill);

      count.className = 'wstn-inline-rating__count';
      count.textContent = '(' + parsed.reviewCount + ')';

      summary.setAttribute('aria-label', parsed.ratingValue.toFixed(1) + ' out of 5 stars from ' + parsed.reviewCount + ' reviews');
      summary.appendChild(meter);
      summary.appendChild(count);
      summary.classList.remove('is-hidden');
    });
  }

  function initProductFormBindings(root) {
    var forms = root.querySelectorAll('form[is="product-form"]');

    forms.forEach(function (form) {
      if (form.dataset.wstnProductBindingsReady === 'true') {
        return;
      }

      form.dataset.wstnProductBindingsReady = 'true';
      form.addEventListener('product:rerender', function () {
        requestAnimationFrame(function () {
          init(document);
        });
      });
    });
  }

  function init(root) {
    var scopedRoot = root || document;
    scrubAudioUrls(scopedRoot);
    watchForInjectedContent();
    syncMotionConstants();
    initProductFormBindings(scopedRoot);
    initMarquees(scopedRoot);
    initReveal(scopedRoot);
    initCountups(scopedRoot);
    initSlider(scopedRoot);
    initReviewSummaries(scopedRoot);
  }

  window.WSTNUX = {
    MOTION: MOTION,
    init: init,
    scrubAudioUrls: scrubAudioUrls,
    prefersReducedMotion: prefersReducedMotion
  };

  // This file is loaded with defer, so the document is already parsed by the time it runs: the
  // sweep and the watcher start here rather than waiting for DOMContentLoaded, because the
  // stylesheet holds the description back from painting until the sweep has marked it safe.
  scrubAudioUrls(document);
  watchForInjectedContent();

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
